
<div id="global-loader">
    <img src="./assets/images/loader.svg" class="loader-img" alt="Loader" />
</div>
<div class="page main-signin-wrapper">
    <section class="signup__area po-rel-z1 pt-100 pb-145">
        <div class="container shapes-div">
            <div class="row">
                <div class="sign__shape">
                    <img src="assets/images/man-1.png" alt="" class="man-1" />
                    <img src="assets/images/man-2.png" alt="" class="man-2" />
                    <img src="assets/images/circle.png" alt="" class="circle" />
                    <img src="assets/images/zigzag.png" alt="" class="zigzag" />
                    <img src="assets/images/dot.png" alt="" class="dot" />
                    <img src="assets/images/sign-up.png" alt="" class="bg" />
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
                    <div class="sign__wrapper white-bg">
                        <div class="sign__header mb-5">
                            <div class="sign__in text-center">
                                <h2>User Details</h2>
                            </div>
                        </div>
                        <div class="sign__form">
                            <form [formGroup]="debUserForm" novalidate>
                                <div class="sign__input-wrapper mb-4">
                                    <h6>Dear {{DebUsername}}, as per DEB ID: {{DebId}}, the following information has been retrieved. Please confirm if it is yours. Your User name and Password will be sent to {{DebMob}} and {{DebEmail}}.</h6>
                                    <h6>For your reference, please save this information.</h6>
                                </div>
                                <div class="sign__input-wrapper mb-4">
                                    <h6>Name</h6>
                                    <div class="sign__input">
                                        <input required type="text" formControlName="debName" readonly/>
                                    </div>
                                </div>
                                <div class="sign__input-wrapper mb-4">
                                    <h6>Gender </h6>
                                    <div class="sign__input">
                                        <input required type="text" formControlName="debGender" readonly/>
                                    </div>
                                </div>
                                <div class="sign__input-wrapper mb-4">
                                    <h6>Date of Birth </h6>
                                    <div class="sign__input">
                                        <input required type="text" formControlName="debDOB" readonly/>
                                    </div>
                                </div>
                                <div class="sign__input-wrapper mb-4">
                                    <h6>Email </h6>
                                    <div class="sign__input">
                                        <input required type="text" formControlName="debEmail" readonly/>
                                    </div>
                                </div>
                                <div class="sign__input-wrapper mb-4">
                                    <h6>Mobile </h6>
                                    <div class="sign__input">
                                        <input required type="text" formControlName="debMobile" readonly/>
                                    </div>
                                </div>
                                <div class="sign__input-wrapper mb-4">
                                    <h6>ABC ID </h6>
                                    <div class="sign__input">
                                        <input required type="text" formControlName="ABCID" readonly/>
                                    </div>
                                </div>
                                <div class="sign__input-wrapper mb-4">
                                    <h6>DEB ID </h6>
                                    <div class="sign__input">
                                        <input required type="text" formControlName="DEBID" readonly/>
                                    </div>
                                </div>
                               
                                <button class="e-btn w-100 colfff" type="submit" (click)="registerDEBUser()">Register</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
  

